import React, { useState } from "react";
import X from "../assets/images/X.png";
import Linkedin from "../assets/images/Linkedin.png";
import GenericPopup from "./popup/en/en-footer-popup";
import arrowIconWhite from "../assets/images/Vector_btn.png";

export default function Footer() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <>
        <section className="bg-[#0080E0] flex flex-col gap-5 items-center py-10 md:py-16 px-5">

            <h2 className="text-[34px] text-[#fff] font-normal">
                Follow us on
            </h2>

            <div className="flex flex-row gap-3">
                <a href="https://x.com/RealeGroup" target="_blank">
                    <img className="w-[30px]" src={X} alt="X"></img>
                </a>
                <a href="https://www.linkedin.com/company/reale-group/" target="_blank">
                    <img className="w-[30px]" src={Linkedin} alt="Linkedin"></img>
                </a>
            </div>

            <p className="text-center text-[#fff] text-[16px] md:text-[20px]">
                Reale Mutua Assicurazioni - Via Corte d'Appello 11, 10122 Torino<br/>
                Iscritta al Registro delle Imprese di Torino, R.E.A. n.9806 - Partita IVA 11998320011 / C.F. 00875360018
            </p>

            <div className="flex flex-row gap-2 justify-center text-white">
                <a className="text-[16px] md:text-[18px] font-bold text-[#fff] text-center" href="https://www.realegroup.eu/EN/careers" target="_blank">Careers</a>
                -
                <a className="text-[16px] md:text-[18px] font-bold text-[#fff] text-center" href="/en/cookie-policy" target="_blank">Cookie Policy</a>
                -
                <a className="text-[16px] md:text-[18px] font-bold text-[#fff] text-center" href="https://www.realegroup.eu/EN/privacy-policy" target="_blank">Privacy Policy</a>
                -
                <a className="text-[16px] md:text-[18px] font-bold text-[#fff] text-center" href="https://www.realegroup.eu/IT/accessibilita" target="_blank">Accessibility</a>
            </div>

            <button
                className="bt-secondary text-sm px-4 py-2 mt-2"
                onClick={() => setIsPopupOpen(true)}
            >
            <img src={arrowIconWhite} alt="Arrow" className="inline-block mr-2 w-[20px] h-[20px]" />
                Credits and contacts
            </button>

        </section>

        {/* Popup dei Credits */}
        <GenericPopup
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
        />
     </>
    );
}